import { animated } from 'react-spring';
import styled from 'styled-components';

export const StyledAdminSiteViewportPositioner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 1rem 1rem 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

StyledAdminSiteViewportPositioner.displayName = 'AdminSiteViewportPositioner';

export const AdminSiteViewportPositioner = animated(
  StyledAdminSiteViewportPositioner,
);
